<template>
	<el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" status-icon>
		<el-row>
			<el-col :span="6">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name" />
				</el-form-item>
			</el-col>
      <el-col :span="6">
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="ruleForm.realName" />
        </el-form-item>
      </el-col>
			<el-col :span="6">
				<el-form-item label="性别" prop="gender">
					<el-select v-model="ruleForm.gender" placeholder="性别">
						<el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
							:value="item.label" />
					</el-select>
				</el-form-item>
			</el-col>
    </el-row>
    <el-row>
			<el-col :span="12">
				<el-form-item label="部门" prop="department.id">
					<el-select v-model="ruleForm.department.id" placeholder="部门" style="width: 100%;">
						<el-option v-for="item in departmentOptions" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>
			</el-col>
      <el-col :span="6">
        <el-form-item label="变动日期" prop="departmentDate">
          <el-date-picker v-model="ruleForm.departmentDate" type="month" format="YYYY-MM"
                          value-format="YYYY.MM.DD" placeholder="部门变动生效日期" />
        </el-form-item>
      </el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<el-form-item label="岗位级别" prop="jobLevel">
					<el-select v-model="ruleForm.jobLevel" placeholder="岗位级别">
						<el-option v-for="item in jobOptions" :key="item.id" :label="item.name"
							:value="item.name" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="变动日期" prop="jobLevelDate">
                    <el-date-picker v-model="ruleForm.jobLevelDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="岗位级别变动生效日期" />
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="饭补级别" prop="mealLevel">
					<el-select v-model="ruleForm.mealLevel" placeholder="饭补级别">
						<el-option v-for="item in mealOptions" :key="item.id" :label="item.name"
							:value="item.name" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="变动日期" prop="mealLevelDate">
                    <el-date-picker v-model="ruleForm.mealLevelDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="饭补级别变动生效日期" />
				</el-form-item>
			</el-col>
            <el-col :span="6">
                <el-form-item label="是否有车补" prop="carLevel">
                    <el-select v-model="ruleForm.carLevel" placeholder="是否有车补">
                        <el-option v-for="item in carOptions" :key="item.value" :label="item.label"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="变动日期" prop="carLevelDate">
                    <el-date-picker v-model="ruleForm.carLevelDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="车补变动生效日期" />
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="是否住宿" prop="accommodation">
                    <el-select v-model="ruleForm.accommodation" placeholder="是否住宿">
                        <el-option v-for="item in accommodationOptions" :key="item.value" :label="item.label"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="变动日期" prop="accommodationDate">
                    <el-date-picker v-model="ruleForm.accommodationDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="住宿变动生效日期" />
                </el-form-item>
            </el-col>
		</el-row>
        <el-row>
            <el-col :span="6">
                <el-form-item label="社保级别" prop="insureLevel">
                    <el-select v-model="ruleForm.insureLevel" placeholder="社保级别" clearable>
                        <el-option v-for="item in insureLevelOptions" :key="item.id" :label="item.name"
                                   :value="item.name" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="变动日期" prop="insureLevelDate">
                    <el-date-picker v-model="ruleForm.insureLevelDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="社保级别变动生效日期" />
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="绩效扣款等级系数" prop="performanceLevel">
                    <el-input v-model="ruleForm.performanceLevel" placeholder="绩效扣款等级系数" type="Number" />
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="变动日期" prop="performanceLevelDate">
                    <el-date-picker v-model="ruleForm.performanceLevelDate" type="month" format="YYYY-MM"
                                    value-format="YYYY.MM.DD" placeholder="绩效扣款等级系数变动生效日期" />
                </el-form-item>
            </el-col>
        </el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="出生年月" prop="birthday">
					<el-date-picker v-model="ruleForm.birthday" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="出生年月" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="文化程度" prop="education">
					<el-select v-model="ruleForm.education" placeholder="文化程度">
						<el-option v-for="item in cultureOptions" :key="item.value" :label="item.label"
							:value="item.label" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="政治面貌" prop="politics">
					<el-select v-model="ruleForm.politics" placeholder="政治面貌">
						<el-option v-for="item in faceOptions" :key="item.value" :label="item.label"
							:value="item.label" />
					</el-select>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="身份证号" prop="idCard">
					<el-input v-model="ruleForm.idCard" placeholder="身份证号" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="ruleForm.phone" placeholder="联系电话" type="number" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="籍贯" prop="nativePlace">
					<el-input v-model="ruleForm.nativePlace" placeholder="籍贯" />
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="开户银行" prop="bank">
					<el-input v-model="ruleForm.bank" placeholder="开户银行" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="银行账号" prop="bankAccount">
					<el-input v-model="ruleForm.bankAccount" placeholder="银行账号" />
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="入职时间" prop="workTime">
					<el-date-picker v-model="ruleForm.workTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="入职时间" />
				</el-form-item>
			</el-col>
			<el-col :span="16">
				<el-form-item label="通讯地址" prop="address">
					<el-input v-model="ruleForm.address" placeholder="通讯地址" />
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="社保入保时间" prop="socialSecurityTime">
					<el-date-picker v-model="ruleForm.socialSecurityTime" type="month" format="YYYY-MM"
						value-format="YYYY.MM.DD" placeholder="社保入保时间" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="入保企业" prop="insure">
					<el-select v-model="ruleForm.socialSecurityCompany" placeholder="入保企业" clearable>
						<el-option v-for="item in insureOptions" :key="item.id" :label="item.name"
							:value="item.name" />
					</el-select>
				</el-form-item>
			</el-col>
            <el-col :span="8">
                <el-form-item label="身份证归档日期" prop="idCardTime">
                    <el-date-picker v-model="ruleForm.idCardTime" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="身份证归档日期" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
			<el-col :span="8">
				<el-form-item label="劳动合同起始" prop="laborContractStartDate">
                    <el-date-picker v-model="ruleForm.laborContractStartDate" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="劳动合同起始日期" />
				</el-form-item>
			</el-col>
            <el-col :span="8">
                <el-form-item label="劳动合同终止" prop="laborContractEndDate">
                    <el-date-picker v-model="ruleForm.laborContractEndDate" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="劳动合同终止日期" />
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="毕业证归档日期" prop="diplomaTime">
                    <el-date-picker v-model="ruleForm.diplomaTime" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="毕业证归档日期" />
                </el-form-item>
            </el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="商业保险起始" prop="commercialInsuranceStartDate">
					<el-date-picker v-model="ruleForm.commercialInsuranceStartDate" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="商业保险起始日期" />
				</el-form-item>
			</el-col>
            <el-col :span="8">
                <el-form-item label="商业保险终止" prop="commercialInsuranceEndDate">
                    <el-date-picker v-model="ruleForm.commercialInsuranceEndDate" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="商业保险终止日期" />
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="劳动合同归档日期" prop="contractFileTime">
                    <el-date-picker v-model="ruleForm.contractFileTime" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY.MM.DD" placeholder="劳动合同归档日期" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
			<el-col :span="8">
				<el-form-item label="面试日期" prop="interviewTime">
					<el-date-picker v-model="ruleForm.interviewTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="面试日期" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="面试情况" prop="interviewResult">
					<el-input v-model="ruleForm.interviewResult" placeholder="面试情况" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="转正日期" prop="regularTime">
					<el-date-picker v-model="ruleForm.regularTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="转正日期" />
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="学习考试归档日期" prop="studyTime">
					<el-date-picker v-model="ruleForm.studyTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="学习考试归档日期" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="七日入职谈话归档日期" prop="sevenDayTime">
					<el-date-picker v-model="ruleForm.sevenDayTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="七日入职谈话归档日期" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="三十日入职谈话归档日期" prop="thirtyDayTime">
					<el-date-picker v-model="ruleForm.thirtyDayTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="三十日入职谈话归档日期" />
				</el-form-item>
			</el-col>
        </el-row>
        <el-row>
            <el-col :span="8">
                <el-form-item label="是否有工龄工资" prop="isWorkAge">
                    <el-select v-model="ruleForm.isWorkAge" placeholder="是否发放工龄工资">
                        <el-option v-for="item in workAgeOptions" :key="item.value" :label="item.label"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
          <el-col :span="8">
            <el-form-item label="排序" prop="interviewResult">
                <el-input v-model="ruleForm.sort" type="number" placeholder="排序，值越大排在越前面" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="财务报表实发工资额" prop="financeAmount">
              <el-input v-model="ruleForm.financeAmount" type="number" placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="8">
                <el-form-item label="在职状态" prop="status">
                    <el-select v-model="ruleForm.status" placeholder="在职状态">
                        <el-option v-for="item in onJobOptions" :key="item.value" :label="item.label"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
			<el-col :span="8" v-if="ruleForm.status == 2">
				<el-form-item label="离职日期" prop="leaveTime">
					<el-date-picker v-model="ruleForm.leaveTime" type="date" format="YYYY-MM-DD"
						value-format="YYYY.MM.DD" placeholder="离职日期" />
				</el-form-item>
			</el-col>
            <el-col :span="8" v-if="ruleForm.status == 2">
                <el-form-item label="离职情况" prop="leaveResult">
                    <el-input v-model="ruleForm.leaveResult" placeholder="离职情况" />
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="虚拟人员" prop="isVirtual">
                    <el-select v-model="ruleForm.isVirtual" placeholder="是否为虚拟人员">
                        <el-option v-for="item in virtualOptions" :key="item.value" :label="item.label"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<el-form-item label="" prop=""> </el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="" prop=""> </el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="" prop=""> </el-form-item>
			</el-col>
		</el-row>
		<el-form-item>
			<el-button  type="primary" class="main-btn main-btn-primary" @click="submitForm(ruleFormRef)">
				立即提交
			</el-button>
			<el-button class="main-btn" @click="resetForm(ruleFormRef)">重置</el-button>
		</el-form-item>
	</el-form>
</template>

<script setup>
	import {
		reactive,
		ref,
		onMounted,
        defineProps,
        defineEmits,
        watch
	} from "vue";
	import {
		fetchList as fetchDepartmentList
	} from "@/api/department";

    const ruleFormRef = ref();
    const defaultForm = {
        name: "",
        department: {
            id: "",
        },
        gender: "",
        post: "",
        postPrice: "",
        meal: "",
        mealPrice: "",
        birthday: "",
        education: "",
        politics: "",
        workTime: "",
        address: "",
        phone: "",
        nativePlace: "",
        idCard: "",
        bank: "",
        bankAccount: "",
        socialSecurityTime: "",
        insure: "",
        contractLimit: "",
        commercialInsuranceTime: "",
        interviewTime: "",
        interviewResult: "",
        regularTime: "",
        idCardTime: "",
        diplomaTime: "",
        contractFileTime: "",
        studyTime: "",
        sevenDayTime: "",
        thirtyDayTime: "",
        leaveTime: "",
        leaveResult: "",
        financeAmount: 0,
        isVirtual: 0
    }
    const ruleForm = ref({});

    const props = defineProps(['info'])
    watch(props, (newVal, oldVal) => {
        console.log(newVal.info)
        if (newVal.info) {
            ruleForm.value = JSON.parse(JSON.stringify(newVal.info))
        } else {
            ruleForm.value = JSON.parse(JSON.stringify(defaultForm))
        }
    }, {immediate: true, deep: true})

    const carOptions = ref([
        {
            value: 1,
            label: "有"
        },
        {
            value: 0,
            label: "无"
        }
    ])
    const accommodationOptions = ref([
        {
            value: 1,
            label: "是"
        },
        {
            value: 0,
            label: "否"
        }
		])
		const virtualOptions = ref([
			{
				value: 1,
				label: "是"
			},
			{
				value: 0,
				label: "否"
			}
		])
	onMounted(() => {
		// getList();
		getDepartmentList();
        getJobList();
        getMealList();
        getInsureList();
        getInsureCompanyList();
	});

    import { fetchList as fetchJobList } from "@/api/jobLevel";
    const jobOptions = ref([])
    const getJobList = () => {
        fetchJobList().then((res) => {
            let list = res.data.list;
            jobOptions.value = list
        });
    };
    import { fetchList as fetchMealList } from "@/api/mealLevel";
    const mealOptions = ref([])
    const getMealList = () => {
        fetchMealList().then((res) => {
            let list = res.data.list;
            mealOptions.value = list
        });
    };
    import { fetchLast } from "@/api/insureLevel";
    const insureLevelOptions = ref([])
    const getInsureList = () => {
        fetchLast().then((res) => {
            let list = res.data.insureLevels;
            insureLevelOptions.value = list
        });
    };
    import { fetchList as fetchInsureCompanyList } from "@/api/insureCompany";
    const insureOptions = ref([])
    const getInsureCompanyList = () => {
        fetchInsureCompanyList().then((res) => {
            let list = res.data.list;
            insureOptions.value = list
        });
    };
    // 选择部门
	const departmentOptions = ref([]);
	const getDepartmentList = () => {
		fetchDepartmentList().then((res) => {
			let list = res.data.list;
			departmentOptions.value = [];
			list.forEach((item) => {
				departmentOptions.value.push({
					value: item.id,
					label: item.name,
				});
			});
		});
	};
	// 岗位级别
	const postOptions = [{
			value: 1,
			label: "S1",
		},
		{
			value: 2,
			label: "S2",
		},
	];
	// 性别
	const genderOptions = [{
			value: 1,
			label: "男",
		},
		{
			value: 2,
			label: "女",
		},
	];
	//文化程度
	const cultureOptions = [{
			value: 0,
			label: "初中",
		},
		{
			value: 1,
			label: "高中",
		},
		{
			value: 2,
			label: "中专",
		},
		{
			value: 3,
			label: "大专",
		},
		{
			value: 4,
			label: "本科",
		},
		{
			value: 5,
			label: "硕士",
		},
		{
			value: 6,
			label: "博士",
		},
		{
			value: 7,
			label: "博士后",
		},
	];
	// 政治面貌
	const faceOptions = [{
			value: 1,
			label: "团员",
		},
		{
			value: 2,
			label: "党员",
		},
		{
			value: 3,
			label: "群众",
		},
	];
	// 在职状态
	const onJobOptions = [{
			value: 1,
			label: "在职",
		},
		{
			value: 2,
			label: "离职",
		},
	];

	const rules = reactive({
		name: [{
			required: true,
			message: "请输入姓名",
			trigger: "blur",
		}, ],
		"department.id": [{
			required: true,
			message: "请选择部门",
			trigger: "change",
		}, ],
		gender: [{
			required: true,
			message: "请选择性别",
			trigger: "change",
		}, ],
        leaveTime: [{
            type: "date",
            required: true,
            message: "请输入离职时间",
            trigger: "change",
        }, ],
		phone: [{
			required: true,
			message: "请输入手机号",
			trigger: "blur",
		}, {
			pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
			message: "请输入正确的电话",
			trigger: "blur",
		}, ],
		idCard: [{
			required: true,
			message: '请输入身份证号',
			trigger: 'blur'
		}, {
			min: 15,
			max: 18,
			pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
			message: '请输入正确的身份证号码',
			trigger: 'blur'
		}],
		status:[{
			required: true,
			message: "请选择在职状态",
			trigger: "change",
		}],
        performanceLevel: [{
            required: true,
            message: "请输入绩效扣款等级系数",
            trigger: "blur",
        }],
	});

    const emit = defineEmits(['onSave'])
	const submitForm = async (formEl) => {
		if (!formEl) return;
		await formEl.validate((valid, fields) => {
			if (valid) {
                emit('onSave',ruleForm.value)
				console.log("submit!");
			} else {
				console.log("error submit!", fields);
			}
		});
	};

	const resetForm = (formEl) => {
		if (!formEl) return;
		formEl.resetFields();
	};

    const workAgeOptions = ref([
        {
            value: 1,
            label: "是",
        },
        {
            value: 0,
            label: "否",
        },
    ])
</script>
<style lang="scss" scoped>
	.el-form{
		// max-height: 65vh;
		// overflow-y: auto;
	}
	::v-deep .el-form-item__label {
		align-items: center;
		line-height: 16px;
		padding: 0 12px 0 4px;
		text-align: right;
	}
</style>
